var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPauseorange(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 14,
    viewBox: "0 0 12 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_14277",
    "data-name": "Group 14277",
    transform: "translate(-1251 -108.535)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3733",
    "data-name": "Rectangle 3733",
    width: 4,
    height: 14,
    rx: 1,
    transform: "translate(1251 108.535)",
    fill: "#fa8008"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3734",
    "data-name": "Rectangle 3734",
    width: 4,
    height: 14,
    rx: 1,
    transform: "translate(1259 108.535)",
    fill: "#fa8008"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPauseorange);
export default __webpack_public_path__ + "static/media/pauseorange.f74b60cb5127ded9f0e7a85bcde2dddd.svg";
export { ForwardRef as ReactComponent };